export const WRITING_SIGNAL_UI = {
  SPECIFIC_DETAIL: {
    inline: true,
    highlightClass: "ws-highlight--green-medium",
    labelClass: "ws-inline-label ws-inline-label--green",
    label: "Specific detail",
    family: "Green",
    familyLabel: "Specific detail",
  },
  SENSORY_DETAIL: {
    inline: true,
    highlightClass: "ws-highlight--orange-medium",
    labelClass: "ws-inline-label ws-inline-label--orange",
    label: "Sensory detail",
    family: "Orange",
    familyLabel: "Sensory detail",
  },
  ACTION: {
    inline: true,
    highlightClass: "ws-highlight--blue-dark",
    labelClass: "ws-inline-label ws-inline-label--blue",
    label: "Action",
    family: "Blue",
    familyLabel: "Action",
  },
  DIALOGUE: {
    inline: true,
    highlightClass: "ws-highlight--teal-medium",
    labelClass: "ws-inline-label ws-inline-label--teal",
    label: "Dialogue",
    family: "Teal",
    familyLabel: "Dialogue",
  },
  INTERNAL_THOUGHT: {
    inline: true,
    highlightClass: "ws-highlight--purple-medium",
    labelClass: "ws-inline-label ws-inline-label--purple",
    label: "Internal thought",
    family: "Purple",
    familyLabel: "Internal thought",
  },
  EMOTION: {
    inline: true,
    highlightClass: "ws-highlight--red-light",
    labelClass: "ws-inline-label ws-inline-label--red",
    label: "Emotion",
    family: "Pink",
    familyLabel: "Emotion",
  },
  VERB_STRENGTH: {
    inline: true,
    highlightClass: "ws-highlight--indigo-medium",
    labelClass: "ws-inline-label ws-inline-label--indigo",
    label: "Strong verb",
    family: "Indigo",
    familyLabel: "Verb strength",
  },
  REPETITION: {
    inline: true,
    highlightClass: "ws-highlight--amber-dark",
    labelClass: "ws-inline-label ws-inline-label--amber",
    label: "Repetition",
    family: "Amber",
    familyLabel: "Repetition",
  },
};

const SIGNAL_ALIASES = {
  IMAGERY: "SENSORY_DETAIL",
  VOICE: "INTERNAL_THOUGHT",
  CLICHE: "REPETITION",
};

export function resolveSignalName(rawLabel) {
  const base = String(rawLabel || "").trim().toUpperCase();
  if (!base) return "";
  return SIGNAL_ALIASES[base] || base;
}
